export default __webpack_public_path__ + "static/media/newsletter-desktop-background.be121bb4.svg";